import React, { useState, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import Footer from "../common-component/Footer";
import Header from "../common-component/Header";
import NewHeader from "../common-component/NewHeader";
import router from "../Router";
import Loader from "../Loader/Loader";

const App: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const currentPath = window.location.pathname;
  const isAuthPage = ["/vendor/login", "/vendor/signup"].includes(currentPath);
  const isHomePage = currentPath === "/";

  useEffect(() => {
    if (isHomePage) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [isHomePage]);

  return (
    <>
      {loading && isHomePage ? (
        <div className="loader">
          <Loader />
        </div>
      ) : (
        <>
          {!isAuthPage && (isHomePage ? <Header /> : <NewHeader />)}
          <RouterProvider router={router} />
          {!isAuthPage && <Footer />}
        </>
      )}
    </>
  );
};

export default App;
